import React, { useState } from "react";
import { uploadDocument } from "../../api/adminApi";
import { useToast } from "../common/ToastProvider";

export default function UploadDocument({ onUploaded }) {
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState("");
  const [signMode, setSignMode] = useState("BOTH");
  const [expiryDays, setExpiryDays] = useState(7);
  const [uploading, setUploading] = useState(false);

  const toast = useToast();

  const formatFileSize = (size) => {
    if (!Number.isFinite(size) || size <= 0) {
      return "0 KB";
    }

    if (size < 1024 * 1024) {
      return `${Math.max(1, Math.round(size / 1024))} KB`;
    }

    return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  };

  const handleUpload = async () => {
    if (!file) {
      setFileError("Please select a PDF file");
      return;
    }

    setFileError("");

    try {
      setUploading(true);
      const res = await uploadDocument(file, signMode, expiryDays);
      onUploaded(res.data);
      toast.success("Document uploaded successfully");
      setFile(null);
    } catch (e) {
      toast.error("Failed to upload document");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="card">
      <div className="form-grid">
        <div>
          <label className="label">
            PDF File <span style={{ color: "red" }}>*</span>
          </label>
          <div className="pdf-picker">
            <input
              id="pdfFileUpload"
              className="file-input pdf-picker-input"
              type="file"
              accept=".pdf"
              onChange={(e) => {
                const selectedFile = e.target.files[0] || null;
                setFile(selectedFile);

                if (selectedFile) {
                  setFileError("");
                }
              }}
            />
            <label
              htmlFor="pdfFileUpload"
              className={`pdf-picker-surface ${file ? "has-file" : ""} ${fileError ? "has-error" : ""}`.trim()}
            >
              <span className="pdf-picker-badge">PDF</span>
              <span className="pdf-picker-title">
                {file ? file.name : "Choose a PDF document"}
              </span>
              <span className="pdf-picker-subtitle">
                {file
                  ? `${formatFileSize(file.size)} | Click to replace`
                  : "Click to browse"}
              </span>
            </label>
          </div>
          {fileError && <div className="error">{fileError}</div>}
        </div>

        <div>
          <label className="label">
            Signing Mode <span style={{ color: "red" }}>*</span>
          </label>
          <select
            className="select"
            value={signMode}
            onChange={(e) => setSignMode(e.target.value)}
          >
            <option value="ESIGN">ESIGN</option>
            <option value="DIGITAL">DIGITAL</option>
            <option value="BOTH">BOTH</option>
          </select>
        </div>

        <div>
          <label className="label">
            Expiry (Days) <span style={{ color: "red" }}>*</span>
          </label>
          <select
            className="select"
            value={expiryDays}
            onChange={(e) => setExpiryDays(Number(e.target.value))}
          >
            <option value={1}>1 Day</option>
            <option value={3}>3 Days</option>
            <option value={7}>7 Days</option>
            <option value={14}>14 Days</option>
            <option value={30}>30 Days</option>
          </select>
        </div>

        <div>
          <button
            className="btn btn-primary"
            onClick={handleUpload}
            disabled={uploading}
          >
            {uploading ? "Uploading..." : "Upload Document"}
          </button>
        </div>
      </div>
    </div>
  );
}
